<ng-container *ngIf=" user=== undefined">
  <nav class="navbar navbar-light bg-light justify-content-between">
    <h3>To access your profile sign in !</h3>
    <button class="btn btn-danger btn" (click)="newsService.signIn()">Sign In</button>
  </nav>
</ng-container>
<ng-container *ngIf="!(user=== undefined || user===null)">
  <nav class="navbar navbar-light bg-light justify-content-between">
    <h3>{{user!.displayName}}</h3>
    <button class="btn btn-danger btn" (click)="newsService.signOut()">Sign Out</button>
  </nav>
</ng-container>
<div class="text-center">
  <h1>
    <img style="width: 5%;" src="https://firebasestorage.googleapis.com/v0/b/clouds-covid19.appspot.com/o/coronavirus-icon-isolated-on-vector-31504476.jpg?alt=media&token=46b13833-b6f3-49bb-acea-f6996a09f501" alt="Covid image">
    COVID-19</h1>
  <h4 style="color:grey">Live Updates and Statistics</h4>

  <div  class="container">
    <nav class="navbar navbar-light bg-dark"  style="text-align: justify;">
      <p class="navbar-brand mb-0 override" style="text-align:center !important;color: white;">
        <a [routerLink]="['/worldwide']"> Worldwide </a>
        >
        {{country?.Country}}</p>
    </nav>

  <!-- <p>{{data}}</p> -->
    <nav class="navbar navbar-light bg-light"  style="margin-bottom: 10pt; margin-top: 10pt">
      <h6 class="navbar-brand mb-0 ">Corona Virus Summary in {{country?.Country}}</h6>
    </nav>

    <table class=" table table-striped table-bordered" style="border-color:white;">
      <tbody class="table-hover" style="border-color:white;">
        <tr class="table-warning">
          <td>New Cases</td><td>{{country?.NewConfirmed.toLocaleString()}}</td>
        </tr>
        <tr class="table-warning">
          <td>Total Cases</td><td>{{country?.TotalConfirmed.toLocaleString()}}</td>
        </tr>
        <tr class="table-warning">
          <td>Active Cases</td><td>{{(country?.TotalConfirmed - country?.TotalRecovered).toLocaleString()}}</td>
        </tr>
        <tr class="table-primary">
          <td>Total Recovered</td><td>{{country?.TotalRecovered.toLocaleString()}}</td>
        </tr>
        <tr class="table-primary">
          <td>New Recovered</td><td>{{country?.NewRecovered.toLocaleString()}}</td>
        </tr>
        <tr class="table-primary">
          <td>Recovery Rate</td><td>{{(country?.TotalRecovered / country?.TotalConfirmed * 100).toFixed(2)}} %</td>
        </tr>
        <tr class="table-danger">
          <td>Total Deaths</td><td>{{country?.TotalDeaths.toLocaleString()}}</td>
        </tr>
        <tr class="table-danger">
          <td>New Deaths</td><td>{{country?.NewDeaths.toLocaleString()}}</td>
        </tr>
        <tr class="table-danger">
          <td>Mortality Rate</td><td>{{(country?.TotalDeaths / country?.TotalConfirmed * 100).toFixed(2)}} %</td>
        </tr>
      </tbody>
    </table>

    <nav class="navbar navbar-light bg-light"  style="margin-bottom: 10pt; margin-top: 10pt">
      <h6 class="navbar-brand mb-0 ">Corona Virus Cases Distribution in {{country?.Country}}</h6>
    </nav>
        <div class="chart" style="margin-bottom: 10pt;">
          <canvas baseChart
            [data]="pieChartData"
            [labels]="pieChartLabels"
            [chartType]="pieChartType"
            [options]="pieChartOptions"
            [plugins]="pieChartPlugins"
            [legend]="pieChartLegend"
            [colors]="pieChartColors">

          </canvas>
    </div>


    <nav class="navbar navbar-light bg-light"  style="margin-bottom: 10pt; margin-top: 10pt">
      <h6 class="navbar-brand mb-0 ">Daily Corona Virus Cases in {{country?.Country}}</h6>
    </nav>

    <div style="display: block;">
      <canvas baseChart
        [datasets]="barChartData2"
        [labels]="barChartLabels"
        [options]="barChartOptions"
        [plugins]="barChartPlugins"
        [legend]="barChartLegend"
        [chartType]="barChartType">
      </canvas>
    </div>


  <nav class="navbar navbar-light bg-light"  style="margin-bottom: 10pt; margin-top: 10pt">
    <h6 class="navbar-brand mb-0 ">Total Corona Virus Cases in {{country?.Country}}</h6>
  </nav>
    <div class="flex" style="margin-bottom: 10pt;">
      <div class="flex-item">
        <div style="display: block;">
        <canvas baseChart width="400" height="400"
                    [datasets]="lineChartData"
                    [labels]="lineChartLabels"
                    [legend]="lineChartLegend"
                    [chartType]="lineChartType"></canvas>
        </div>
      </div>
      </div>
  <nav class="navbar navbar-light bg-light"  style="margin-bottom: 10pt; margin-top: 10pt">
    <h6 class="navbar-brand mb-0 ">{{country?.Country}} News</h6>
  </nav>

  <div class="row" >
    <ng-container *ngFor="let n of countryNews" >
      <ng-container *ngIf="n.Country === country?.Country">
      <div class="col-sm-4" style="margin-bottom: 10pt;" >

          <div class="card" style="width: 18rem;">
          <div class="card-body">
            <h5 class="card-title">{{country?.Country}} News</h5>
            <h6 class="card-subtitle mb-2 text-muted">news by {{n.User.displayName}}</h6>
            <p class="card-text">{{n.Description}}.</p>
            <a href="#" class="card-link text-right">{{n.Date}}</a>
          </div>
          </div>
        </div>

        </ng-container>

    </ng-container>
  </div>

</div>
<footer class="footer">
  <div class="text-center container">
    <nav class="navbar navbar-light bg-light"  style="margin-bottom: 40pt; margin-top: 10pt">
    <p class="navbar-brand mb-0 " style="text-align: center;"> Data Source:
      <a href="https://covid19api.com/">
                      "COVID-19 API / Johns Hopkins CSSE""
      </a>
    </p>
  </nav>
  </div>

</footer>

